import { Search, X } from 'lucide-react';
import { Button } from './button';
import { Input } from './input';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  'aria-label'?: string;
}

export const SearchInput = ({
  value,
  onChange,
  placeholder = 'Search...',
  'aria-label': ariaLabel = 'Search',
}: SearchInputProps) => {
  return (
    <div className='relative flex-1'>
      <Input
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        icon={!value.trim() ? Search : undefined}
        aria-label={ariaLabel}
        autoComplete='off'
      />
      {value.trim() && (
        <Button
          variant='ghost'
          className='absolute right-2 top-1/2 -translate-y-1/2 h-6 w-6 p-0'
          onClick={() => onChange('')}
          aria-label='Clear search'
        >
          <X className='h-3 w-3' />
        </Button>
      )}
    </div>
  );
};
